<template lang="pug">
div.app
  app-header
  div.app-body
    app-sidebar(:navItems='nav')
    main.main
      app-breadcrumb(:list='list')
      div.container-fluid
        router-view(v-if='list.length > 1')
        Home(v-else)
    app-aside
  app-footer
</template>

<script>
import nav from '../_nav'
import Home from '@/views/Home'
import { db } from '@/firebase'

export default {
  name: 'full',
  data () {
    return {
      nav: [],
      numOfFlags: Number,
    }
  },
  components: {
    Home,
  },
  computed: {
    isHome() {
      return true
    },
    name () {
      // console.log(this.$route.name)
      return this.$route.name
    },
    list () {
      // console.log('routaaa', this.$route.matched)
      return this.$route.matched
    },
    accessLevel() {
      // console.log('abc')
      return this.$store.getters.getProfile
    },
  },
  mounted() {
    // const that = this
    var accessLevel = this.$store.state.profile.accessLevel
    this.nav = nav[accessLevel]
    // if (that.nav) {
    //   db.ref('flags').on('value', (snapshot) => {
    //     for (let i = 0; i < that.nav.length; i++) {
    //       if (that.nav[i].name == 'Interactions' && that.nav[i].badge) {
    //         if (snapshot.numChildren() == 0) {
    //           that.nav[i].badge.text = ''
    //         } else {
    //           that.nav[i].badge.text = snapshot.numChildren()
    //         }
    //         break
    //       }
    //     }
    //   })
    // }
  },
  beforeDestroy() {
    db.ref('flags').off()
  },
  watch: {
    accessLevel() {
      // console.log('abc')
      this.nav = nav[this.accessLevel]
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/layouts/Full.vue?148ea65b